import { TextLink } from '@bfe/moly';
import { useToggle } from 'ahooks';
import { message } from 'antd';
import { FC } from 'react';

import { ConfirmModal } from '@/components/ConfirmModal';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useI18nContext } from '@/i18n/I18n';
import { delApi, delSubAccountApi } from '@/services/apiManagement';
import { $tracing } from '@/utils/tracing';

interface DeleteApiProps {
  /** 列表返回的id */
  apiManagementId: string;
  subAccountId: string;
  isFromSubAccount: boolean;
  refreshTable: () => void;
  disabled?: boolean;
}

export const DeleteApiBtn: FC<DeleteApiProps> = (props) => {
  const [$t] = useI18nContext();
  const [showKickChildModal, { toggle }] = useToggle(false);
  const {
    isFromSubAccount,
    apiManagementId,
    subAccountId,
    refreshTable,
    disabled,
  } = props;
  const { isDemoAccount } = useUserProfile();

  const onDelete = () => {
    if (isFromSubAccount || isDemoAccount) {
      delSubAccountApi({ apiManagementId, subMemberId: subAccountId })
        .then(() => {
          const msg = $t('Key deleted');
          message.success(msg);
          refreshTable();
          toggle();
          // mzry TODO: 确认是否可以使用之前的埋点
          // $tracing.addEvent({
          //   t: 'action',
          //   c: 15141,
          // });
        })
        .catch(() => {
          message.error($t('apiDeleteFail'));
        });
      return;
    }
    delApi(apiManagementId)
      .then(() => {
        const msg = $t('Key deleted');
        message.success(msg);
        refreshTable();
        toggle();
        $tracing.addEvent({
          t: 'action',
          c: 15141,
        });
      })
      .catch(() => {
        message.error($t('apiDeleteFail'));
      });
  };

  return (
    <>
      <TextLink
        variant="primary"
        size="normal"
        onClick={toggle}
        closeIcon
        style={{ width: 'max-content' }}
        disabled={disabled}
      >
        {$t('delete')}
      </TextLink>
      <ConfirmModal
        title={$t('common.tips')}
        showCancelBtn
        isVisible={showKickChildModal}
        content={$t('Are you sure you want to delete this address')}
        onCancel={toggle}
        onConfirm={onDelete}
      />
    </>
  );
};
